import React from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from 'language/i18n';
import Breadcrumb from 'components/Breadcrumb';
import Layout from 'components/partials/Layout';
import LeftMenu from '../components/selling/LeftMenu';
import ContactUs from '../components/ContactUs';
import SellYourMachineIn30Days from '../components/SellYourMachineIn30Days';

const TimedAuction = ({ t }) => {
  const breadcrumbs = [
    {
      label: t('homepage'),
      url: '/',
    },
    {
      label: t('selling'),
      url: '/content/selling/timed-auction',
    },
    {
      label: 'Zaman Ayarlı Açık Artırma',
      url: '/content/selling/timed-auction',
    },
  ];

  return (
    <main className="has-header">
      <div className="container">
        <div className="row mt-4 mb-4 mt-lg-3 mb-lg-3">
          <div className="col">
            <Breadcrumb links={breadcrumbs} />
          </div>
        </div>
        <div className="row">
          <LeftMenu currentPage="timed-auction" />
          <div className="col-md-10 col-lg-11 mt-3 mt-md-0">
            <div className="row mb-20">
              <div className="col">
                <h1 className="h1">Zaman Ayarlı Açık Artırma </h1>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <p>
                  Zaman ayarlı açık artırma; makinanın açık artırma sırasında en yüksek teklifi verene satıldığı satış yöntemidir. Pazarlık usulü açık artırmadan farklı olarak alıcıya ve satıcıya pazarlık yapma imkanı sunmaz.
                </p>
                <p>
                  Zaman Ayarlı Açık Artırma yöntemiyle satışa çıkan makinalarlar bir hafta boyunca kullanıcıların maksimum tekliflerini vermesi için satışa çıkmadan sitede sergilenir.
                  1 haftanın sonunda açık artırma başlatılır. 15 veya 30 gün boyunca açık artırma devam eder.
                  Kullanıcılar, makinanın ilan sayfasında belirtmek istedikleri maksimum teklifi girebilir ya da anlık olarak teklif verebilir.
                </p>
                <p>Açık artırma bittiğinde en yüksek teklifi veren kullanıcı, makina rezerv fiyatını geçtiği taktirde makinayı almaya hak kazanır.</p>
                <p>Teklif veren kullanıcılar, ödedikleri Teminat Bedeli aracılığıyla, manipülasyon olmadan, güvenli,şeffaf ve adil bir şekilde alım işlemlerini gerçekteştirir.</p>
                <p>Zaman Ayarlı Açık Artırma yöntemiyle satışa çıkan makinalarda "Hemen Al" opsiyonu ve pazarlık fırsatı bulunmaz.</p>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <h2 className="h5">Maksimum Teklif</h2>
              </div>
              <div className="col-15">
                <p>
                  Maksimum Teklif alıcıların açık artırma sırasında çıkmak istedikleri en yüksek teklifi temsil eder. Maksimum teklifinizi belirlediğinizde anlık olarak teklif vermenize gerek kalmaz, sistem
                  açık artırmayı kazanmak için gerekli minimum teklifi otomatik olarak verir.
                </p>
                <p>
                  Örneğin maksimum teklifinizi 100.000 olarak belirlediniz. Açık artırmadaki makina ise 60.000 eurodan satışa çıkartıldı. Bu durumda sistem sizin yerinize 61.000 euroluk teklifi yapacaktır.
                </p>
                <p>
                  Eğer başka bir kullanıcı 62.000 euroluk teklif sunarsa sistem sizin yerinize tekrardan 63.000 euroluk teklif yapacaktır.
                </p>
                <p>
                  Tekliflerde yapılan artışlar açık artırmanın minimum artış miktarına göre yapılır. Örneğin açık artırmada minimum artış miktarı 1.000 euro ise 62.000 euroluk teklife karşı 63.000 euro teklif sunulur. Eğer minimum artış
                  miktarı 500 euro ise 62.000 euroluk teklife karşı 62.500 euroluk teklif sunulur. Açık artırmalarda verilen tekliflerin minimum artış miktarı kadar artırılma zorunluluğu vardır. Siz anlık olarak da teklif verseniz veya sistem otomatik olarak teklif de verse bu geçerlidir.
                </p>
                <p>
                  Sistem belirttiğiniz maksimum teklifin üzerinde bir teklif vermez.
                </p>
                <p>
                  Eğer başka bir kullanıcı maksimum teklifinizi geçen bir teklifte bulunursa SMS ve e-mail yollarıyla size anında bildirilir. Bu sayede maksimum teklifinizi artırabilir ya da anlık teklif vermeye başlayabilirsiniz.
                </p>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <h2 className="h5">Rezerv Fiyatı</h2>
              </div>
              <div className="col-15">
                <p>
                  Rezerv fiyatı, makinanın makul kabul edilebilecek en düşük satış fiyatıdır. Satıcı tarafından opsiyonel olarak belirlenir.
                </p>
                <p>
                  Eğer açık artırma bitene kadar rezerv fiyatında veya rezerv fiyatından fazla bir teklif gelmezse açık artırma geçersiz kabul edilir ve makina tekrar satışa sunulur.
                </p>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <h2 className="h5">Ulusal Alıcı Havuzu</h2>
              </div>
              <div className="col-15">
                <p>
                  iyiMakina.com kullanıcıları; bilgisayarları, cep telefonları veya tabletleri aracılığıyla açık artırmalara istediği yerden, istediği saatte online olarak katılabilirler.
                </p>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <h2 className="h5">Doğrudan ve Güvenilir Satış</h2>
              </div>
              <div className="col-15">
                <p>
                  İkinci el iş makinalarınızı arada aracı olmadan, doğrudan alıcılarla buluşturan iyiMakina.com'da; hızlı, şeffaf ve güvenilir yöntemlerle makinanızı kolayca satabilirsiniz.
                </p>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <h2 className="h5">Saatler İçinde Satış ve Devir</h2>
              </div>
              <div className="col-15">
                <p>
                  iyiMakina.com'da makina satmak isteyen kullanıcılar; İster Pazarlık usulü ile, ister Zaman Ayarlı Açık Arıtrma ile makinalarını hızlı, güvenilir ve değerinde satarlar.
                </p>
              </div>
            </div>
            <SellYourMachineIn30Days />
            <ContactUs about="Açık Artırma Süreciyle" />
          </div>
        </div>
      </div>
    </main>
  );
};

TimedAuction.propTypes = {
  t: PropTypes.func,
};

export const getServerSideProps = async () => {
  return {
    props: {
      blackHeader: true,
      headTitle: 'Zaman Ayarlı Açık Artırma',
    },
  };
};

TimedAuction.Layout = Layout;

export default withTranslation('common')(TimedAuction);
